const columns = [
  { title: 'Date', dataIndex: 'date', key: 'date' },
  { title: 'Plan', dataIndex: 'plan', key: 'plan' },
  { title: 'Meal', dataIndex: 'meal', key: 'meal' },
  { title: 'Food Items', dataIndex: 'foodItems', key: 'foodItems' },
  { title: 'Calories', dataIndex: 'calories', key: 'calories' },
];

export default columns;
